import identity from "lodash/identity"

export default function normalize(data, model) {
  const { primaryKey = `id`, normalize = identity } = model

  return {
    id: data[primaryKey],
    data: normalize(data),
  }
}
